/**
 *
 * @file
 * @author
 */

import router from '@/router'
import store from '@/store'


import {
    VUEX_PERSISTENCE_SET_VALUE
}   from '@/store/constants/persistence'


const state = {
    storageKeys: [],
}

const getters = {
    getPersistence: (state) => (key) => {
        var obj
        if (state.storageKeys[key]) {
            obj = state.storageKeys[key]
        }
        return obj;
    },

}

const actions = {
    //EXPECTING:
    //obj.key - ex: jobs
    //obj.value: appliedFilters object
    [VUEX_PERSISTENCE_SET_VALUE]:async ({ commit, state }, obj) => {
        commit(VUEX_PERSISTENCE_SET_VALUE, obj)
    },
}

const mutations = {
    //payload.key - ex: jobs
    //payload.value: appliedFilters object
    [VUEX_PERSISTENCE_SET_VALUE]: (state, payload) => {
        state.storageKeys[payload.key] = payload.value
    },
}

export default {
    state,
    actions,
    mutations,
    getters
}
